import React from 'react';
import {Text, View} from 'react-native';
import {useStyles} from '../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../shared/theme/helpers';
import {IOwnProps} from './model';
import {Html} from '../../../../../shared/components/html';

export default ({fullDescription, howToGet, aboutAcceptor}: IOwnProps) => {
  const styles = useStyles(({theme, isDesktop, mediaOnly}) => ({
    card: {
      backgroundColor: theme.color.primaryNonGreyBackground,
      paddingHorizontal: isDesktop ? 30 : 20,
      paddingVertical: isDesktop ? 40 : 20,
      borderWidth: 1,
      borderColor: theme.color.borderColor,
      borderStyle: 'solid',
      borderRadius: 5,
    },
    cardHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    cardHeaderText: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h2, theme.fonts.action),
      color: theme.color.textColor,
      textTransform: 'uppercase',
      marginTop: 20,
    },
    cardHeaderTextDesc: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h2, theme.fonts.action),
      color: theme.color.textColor,
      textTransform: 'uppercase',
    },
    cardBody: {
      paddingTop: isDesktop ? 20 : 12,
    },
    button: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          width: 40,
          height: 40,
        },
        {
          width: 30,
          height: 30,
        },
      ),
      color: theme.color.primaryColor,
    },
    buttonIcon: {
      color: theme.color.primaryColor,
      zIndex: 2,
    },
  }));

  return (
    <>
      <View style={styles.card}>
        <Text style={styles.cardHeaderTextDesc}>Описание товара</Text>
        <View style={styles.cardBody}>
          <Html content={fullDescription} testID='acceptor-description' />
        </View>
      </View>
      <View style={{marginTop: 20}} />
      <View style={styles.card}>
        <Text style={styles.cardHeaderTextDesc}>Как получить</Text>
        <View style={styles.cardBody}>
          <Html content={howToGet} testID='acceptor-description' />
        </View>
      </View>
      <View style={{marginTop: 20}} />
      <View style={styles.card}>
        <Text style={styles.cardHeaderTextDesc}>О партнере</Text>
        <View style={styles.cardBody}>
          <Html content={aboutAcceptor} testID='acceptor-description' />
        </View>
      </View>
      <View style={{marginTop: 20}} />
    </>
  );
};
